/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactpackprogressheading3Inputs */

const en_artifactpackprogressheading3 = /** @type {(inputs: Artifactpackprogressheading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What you've already done`)
};

const pt_artifactpackprogressheading3 = /** @type {(inputs: Artifactpackprogressheading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que já fez`)
};

/**
* | output |
* | --- |
* | "What you've already done" |
*
* @param {Artifactpackprogressheading3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactpackprogressheading3 = /** @type {((inputs?: Artifactpackprogressheading3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactpackprogressheading3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactpackprogressheading3(inputs)
	return pt_artifactpackprogressheading3(inputs)
});
export { artifactpackprogressheading3 as "artifactPackProgressHeading" }